import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { removeItemsfromOrder } from 'api/order';

import InitialMessage from './InitialMessage';
import Fabrication from './Fabrication';
import Stencils from './Stencils';
import Parts from './Parts';
import AccessoriesDetail from 'product_tabs/tab_accessories/components/cart/AccessoriesDetail';
import Assembly from './Assembly';
import Discount from './Discount';

import {
  validate as stencilsValidate,
} from '../../tab_smt_stencils/stencilSlice';
import {
  validate as partsValidate,
} from '../../tab_parts/bomSlice';
import { 
  validate as assemblyValidate, 
} from 'product_tabs/tab_assembly/assemblySlice';

import { buildForms as buildStencilForms } from 'product_tabs/tab_smt_stencils/utils/builders';
import { buildForms as buildBomForms } from 'product_tabs/tab_parts/utils/builders';
import { buildForms as buildAccessoriesForms } from 'product_tabs/tab_accessories/utils/builders';
import { buildForms as buildAssemblyForms } from 'product_tabs/tab_assembly/utils/builders';

import { selectDataForCart } from '../selector/selectors';

import { showErrors } from '../../alerts/alertSlice';
import { orderProduct } from 'api/order';


const Cart = (props) => {
  const [saving, setSaving] = useState(false);
  const dispatch = useDispatch();
  let total = 0;

  const {
    fabricationSelector,
    buildFabricationForms,
    fabCleanUp,
    onFabValidate,
    projectNumber,
    projectReference,
  } = props;

  const {
    fabProps,
    fabToDestroy,
    fabDataForForms,
    partNumber,
    revision,
  } = useSelector(fabricationSelector)

  const {
    stencils,
    parts,
    accessories,
    assembly,
  } = useSelector(selectDataForCart);

  const {stencilDataForForms, stencilProps, stencilsToDestroy} = stencils;
  const {partDataForForms, partProps, partToDestroy} = parts;
  const {accessoriesDataForForms, accessoryProps, accessoriesToDestroy} = accessories;
  const {assemblyDataForForms, assemblyProps, assemblyToDestroy} = assembly;

  const onAddToCart = async () => {
    // delete products marked as destroy
    const lineItems = [
      ...fabToDestroy,
      ...stencilsToDestroy,
      ...partToDestroy,
      ...accessoriesToDestroy,
      ...assemblyToDestroy,
    ];
  
    if (lineItems && lineItems.length > 0) {
      try {
        const response = await removeItemsfromOrder(lineItems);
      } catch (err) {
        console.error(err)
      }
    }

    const project_number = projectNumber();
    const project_reference = projectReference();

    const forms = [
      ...buildFabricationForms({...fabDataForForms, project_number, project_reference}),
      ...buildAssemblyForms({...assemblyDataForForms, project_number, project_reference}),
      ...buildStencilForms({...stencilDataForForms, partNumber, revision, project_number, project_reference}),
      ...buildBomForms({...partDataForForms, project_number, project_reference}),
      ...buildAccessoriesForms({...accessoriesDataForForms, project_number, project_reference}),
    ];

    for(const form of forms) {
      try {
        const response = await orderProduct(form);
      } catch (err) {
        console.error(err)
      }
    }

    window.location.href = '/cart';
  }

  const onItemsValidate = (validationResult) => {
    if (total <= 0) {
      dispatch(showErrors('Please select some product before add to cart.'));
      return false;
    }
    return true;
  }

  const onClick = () => {
    setSaving(true)

    let validationResult = true;
    validationResult = onFabValidate(validationResult) && validationResult;
    validationResult = dispatch(assemblyValidate(validationResult)) && validationResult;
    validationResult = dispatch(stencilsValidate(validationResult)) && validationResult;
    validationResult = dispatch(partsValidate(validationResult)) && validationResult;
    validationResult = onItemsValidate(validationResult) && validationResult;

    if (!validationResult) {
      setSaving(false)
      return;
    }
    onAddToCart()
  }

  [fabProps, stencilProps, partProps, accessoryProps, assemblyProps].forEach((data) => {
    if (data.selected) {
      total += parseFloat(data.subTotal);
    }
  });

  if (fabProps.selected && stencilProps.selected) {
    total -= parseFloat(stencilProps.subTotal) * 0.3;
  }

  return (
    <div className="inside-product-cart">
      <div className="mb-1 selection-label">Order Summary:</div>
      <InitialMessage selected={fabProps.selected || stencilProps.selected || partProps.selected || accessoryProps.selected || assemblyProps.selected} />
      <Fabrication {...fabProps} cleanUp={fabCleanUp} />
      <Assembly {...assemblyProps} />
      <Stencils {...stencilProps} />
      <Parts {...partProps} />
      <AccessoriesDetail {...accessoryProps} />
      <Discount fabrication={fabProps} stencil={stencilProps} />
      <hr />
      <div className="sub-total">
        SUBTOTAL: ${accounting.toFixed(total, 2)}
      </div>
      <button type="button" className="btn btn-main-action w-100" onClick={onClick} disabled={saving}>
        {saving && <span className="spinner-border spinner-border-sm mr-1" aria-hidden="true" />}
        {saving ? 'ADDING...' : 'ADD TO CART'}
      </button>
    </div>
  )
};

Cart.propTypes = {
  buildFabricationForms: PropTypes.func.isRequired,
  fabricationSelector: PropTypes.func.isRequired,
  fabCleanUp: PropTypes.func.isRequired,
  onFabValidate: PropTypes.func.isRequired,
  projectNumber: PropTypes.func.isRequired,
  projectReference: PropTypes.func.isRequired,
}

export default Cart;
